const prefix = '/admin';

const Routes = {
  Home: prefix + '/',
  Stats: prefix + '/stats',
  Users: prefix + '/users',
  Bookings: prefix + '/bookings',
  Announcements: prefix + '/announcements',
  Settings: prefix + '/settings',
  Performances: prefix + '/performances',
  Subscriptions: prefix + '/subscriptions',
  Segments: prefix + '/segments',
  Prospecter: prefix + '/prospecter',
};

export default Routes;
